"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextElement;
(function (TextElement) {
    TextElement["Span"] = "span";
    TextElement["Label"] = "label";
    TextElement["P"] = "p";
    TextElement["H1"] = "h1";
    TextElement["H2"] = "h2";
    TextElement["H3"] = "h3";
    TextElement["H4"] = "h4";
    TextElement["H5"] = "h5";
    TextElement["H6"] = "h6";
})(TextElement = exports.TextElement || (exports.TextElement = {}));
var DisplayElement;
(function (DisplayElement) {
    DisplayElement["Div"] = "div";
    DisplayElement["Section"] = "section";
    DisplayElement["Article"] = "article";
    DisplayElement["Label"] = "label";
})(DisplayElement = exports.DisplayElement || (exports.DisplayElement = {}));
var FormElement;
(function (FormElement) {
    FormElement["Form"] = "form";
    FormElement["Button"] = "button";
    FormElement["Input"] = "input";
    FormElement["Textarea"] = "textarea";
    FormElement["Select"] = "select";
    FormElement["Option"] = "option";
    FormElement["Anchor"] = "a";
})(FormElement = exports.FormElement || (exports.FormElement = {}));
